import React, { Fragment } from "react";
import HeaderButton from "./HeaderButton.js";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

const OrganizeHeaderOrganisations = (props) => {
    return (
        <Fragment>
            <HeaderButton 
                title="Add organization"
                icon={icon({name: "plus", style: "regular"})}
                type="primary"
                disabled={!props.headerOptions.organisationSelected}
                onClick={() => props.addOrganisation()}
            />            
            <HeaderButton 
                title="Merge organizations"
                icon={icon({name: "layer-group", style: "light"})}
                disabled={!props.headerOptions.nonTopOrganisationSelected}
                onClick={() => props.mergeOrganisation()}
            />

            <HeaderButton 
                title="Remove organization"
                icon={icon({name: "trash-can", style: "light"})}
                disabled={!props.headerOptions.nonTopOrganisationSelected}
                onClick={() => props.removeOrganisation()}
            />
        </Fragment>
    )
}

export default OrganizeHeaderOrganisations;